<template>
  <div>
    <Banner bgsrc="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_banner.png">
      <span class="w-banner_text">{{ this.$t('productDetail.productDetailTitle') }}</span>
    </Banner>
    <div class="w-productDetail_back">
      <div class="w-transform_timing w-back_container" @click="handBackproduct">
        <Animation defaultClass="w-transform_right" animationClass="w-transform_show">
          <i class="iconfont icon-product_icon_back"></i>
          <span class="w-smallTitle_text">{{ this.$t('productDetail.gobackProduct') }}</span>
        </Animation>
      </div>
    </div>
    <div class="w-productDetail_container">
      <div class="w-container_left">
        <div v-for="(item, index) in parductList" :key="index" class="w-left_box">
          <div class="w-left_title" v-if="item.children&&item.children.length>0">
            <span class="w-defaultTitle_text">{{ item.ductName }}</span>
          </div>
          <div class="w-left_title w-transform_timing" v-else @click="handProduct(item)">
            <span :class="['w-defaultTitle_text',{'is-active':isActive==item.deptType}]">{{ item.ductName }}</span>
            <i class=" iconfont icon-common_icon_more"></i>
          </div>
          <div v-for="(item1, index1) in item.children" :key="index1" class="w-transform_timing w-left_item" @click="handProduct(item1)">
            <span :class="['w-button_text',{'is-active':isActive==item1.deptType}]">{{ item1.ductName }}</span>
            <i class="w-button_text iconfont icon-common_icon_more"></i>
          </div>
        </div>
      </div>
      <div class="w-container_right">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-moduleBanner_text">
            {{ productInfo.proTitle }}
          </div>
        </Animation>
        <div class="w-product_img">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <img :src="productInfo.productUrl" alt="#">
          </Animation>
        </div>
        <div class="w-bright_container" v-if="productInfo.brightInfo.length>0">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-defaultTitle_text"> {{this.$t('productDetail.productHighlights')}}</div>
          </Animation>
          <div class="w-bright_box">
            <div v-for="item,index in productInfo.brightInfo" :key="index">
              <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
                <div class="w-bright_item">
                  <div class="w-item_div"><span></span></div>
                  <span class="w-button_text">{{ item }}</span>
                </div>
              </Animation>
            </div>
          </div>
        </div>
        <div class="w-argument_container">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-defaultTitle_text">{{this.$t('productDetail.productParameters')}}</div>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="">
              <div class="w-argument_item w-item_title">
                <span>{{this.$t('productDetail.project')}}</span>
                <span>{{this.$t('productDetail.specification')}}</span>
              </div>
              <div v-for="item,index in productInfo.argument" :key="index" class="w-argument_item">
                <span>{{ item.argumentKey }}</span>
                <span>{{ item.argumentValue }}</span>
              </div>
            </div>
          </Animation>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from '@/components/Banner'
import Animation from '@/components/Animation.vue'
import Footer from '@/components/Footer.vue'

export default {
  props: {
    productId: {
      type: String,
      default: 'D98'
    }
  },
  data () {
    return {
      parductList: [
        {
          ductName: 'D9X' + this.$t('productDetail.series'),
          deptType: 'D9X',
          ductId: 1,
          children: [{
            ductName: 'D98' + this.$t('productDetail.locator'),
            deptType: 'D98',
            ductId: 1
          }, {
            ductName: 'D96' + this.$t('productDetail.locator'),
            deptType: 'D96',
            ductId: 2
          }, {
            ductName: 'D92' + this.$t('productDetail.locator'),
            deptType: 'D92',
            ductId: 3
          }]
        }, {
          ductName: 'D8X' + this.$t('productDetail.series'),
          deptType: 'D8X',
          ductId: 2,
          children: [{
            ductName: 'D82' + this.$t('productDetail.locator'),
            deptType: 'D82',
            ductId: 1
          }]
        }, {
          ductName: 'D6X' + this.$t('productDetail.series'),
          deptType: 'D6X',
          ductId: 3,
          children: [{
            ductName: 'D60' + this.$t('productDetail.locator'),
            deptType: 'D60',
            ductId: 1
          }]
        }, {
          ductName: this.$t('home.productBlueTooth'),
          deptType: '蓝牙信标',
          ductId: 4
        }
      ],
      productList: [{
        proType: 'D98',
        proTitle: 'D98' + this.$t('productDetail.locator'),
        productUrl: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_5.png',
        brightInfo: [this.$t('productDetail.d98Brighttext1'), this.$t('productDetail.d98Brighttext2'), this.$t('productDetail.d98Brighttext3'), this.$t('productDetail.d98Brighttext4'), this.$t('productDetail.d98Brighttext5'), this.$t('productDetail.d98Brighttext6')],
        argument: [{
          argumentKey: this.$t('productDetail.d98ArgumentKey1'),
          argumentValue: this.$t('productDetail.d98ArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey2'),
          argumentValue: this.$t('productDetail.d98ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey3'),
          argumentValue: this.$t('productDetail.d98ArgumentValue3')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey4'),
          argumentValue: this.$t('productDetail.d98ArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey5'),
          argumentValue: this.$t('productDetail.d98ArgumentValue5')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey6'),
          argumentValue: this.$t('productDetail.d98ArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey7'),
          argumentValue: this.$t('productDetail.d98ArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey8'),
          argumentValue: this.$t('productDetail.d98ArgumentValue8')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey9'),
          argumentValue: this.$t('productDetail.d98ArgumentValue9')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey10'),
          argumentValue: this.$t('productDetail.d98ArgumentValue10')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey11'),
          argumentValue: this.$t('productDetail.d98ArgumentValue11')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey12'),
          argumentValue: this.$t('productDetail.d98ArgumentValue12')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey13'),
          argumentValue: this.$t('productDetail.d98ArgumentValue13')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey14'),
          argumentValue: this.$t('productDetail.d98ArgumentValue14')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey15'),
          argumentValue: this.$t('productDetail.d98ArgumentValue15')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey16'),
          argumentValue: this.$t('productDetail.d98ArgumentValue16')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey17'),
          argumentValue: this.$t('productDetail.d98ArgumentValue17')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey18'),
          argumentValue: this.$t('productDetail.d98ArgumentValue18')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey19'),
          argumentValue: this.$t('productDetail.d98ArgumentValue19')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey20'),
          argumentValue: this.$t('productDetail.d98ArgumentValue20')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey21'),
          argumentValue: this.$t('productDetail.d98ArgumentValue21')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey22'),
          argumentValue: this.$t('productDetail.d98ArgumentValue22')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey23'),
          argumentValue: this.$t('productDetail.d98ArgumentValue23')
        }]
      }, {
        proType: 'D96',
        proTitle: 'D96' + this.$t('productDetail.locator'),
        productUrl: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_6.png',
        brightInfo: [this.$t('productDetail.d98Brighttext1'), this.$t('productDetail.d98Brighttext2'), this.$t('productDetail.d98Brighttext3'), this.$t('productDetail.d98Brighttext4'), this.$t('productDetail.d96Brighttext1'),],
        argument: [{
          argumentKey: this.$t('productDetail.d98ArgumentKey1'),
          argumentValue: this.$t('productDetail.d98ArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey2'),
          argumentValue: this.$t('productDetail.d98ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey3'),
          argumentValue: this.$t('productDetail.d98ArgumentValue3')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey4'),
          argumentValue: this.$t('productDetail.d98ArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey5'),
          argumentValue: this.$t('productDetail.d98ArgumentValue5')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey6'),
          argumentValue: this.$t('productDetail.d98ArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey7'),
          argumentValue: this.$t('productDetail.d98ArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey8'),
          argumentValue: this.$t('productDetail.d98ArgumentValue8')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey9'),
          argumentValue: this.$t('productDetail.d98ArgumentValue9')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey10'),
          argumentValue: this.$t('productDetail.d98ArgumentValue10')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey11'),
          argumentValue: this.$t('productDetail.d98ArgumentValue11')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey13'),
          argumentValue: this.$t('productDetail.d98ArgumentValue13')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey14'),
          argumentValue: this.$t('productDetail.d98ArgumentValue14')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey15'),
          argumentValue: this.$t('productDetail.d98ArgumentValue15')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey16'),
          argumentValue: this.$t('productDetail.d98ArgumentValue16')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey17'),
          argumentValue: this.$t('productDetail.d98ArgumentValue17')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey18'),
          argumentValue: this.$t('productDetail.d98ArgumentValue18')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey19'),
          argumentValue: this.$t('productDetail.d98ArgumentValue19')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey20'),
          argumentValue: '180mm*27.5mm*19mm'
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey21'),
          argumentValue: '86.5g'
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey22'),
          argumentValue: this.$t('productDetail.d98ArgumentValue22')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey23'),
          argumentValue: this.$t('productDetail.d98ArgumentValue23')
        }]
      }, {
        proType: 'D92',
        proTitle: 'D92' + this.$t('productDetail.locator'),
        productUrl: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_7.png',
        brightInfo: [this.$t('productDetail.d98Brighttext1'), this.$t('productDetail.d98Brighttext2'), this.$t('productDetail.d98Brighttext3'), this.$t('productDetail.d98Brighttext4'), this.$t('productDetail.d96Brighttext1')],
        argument: [{
          argumentKey: this.$t('productDetail.d98ArgumentKey1'),
          argumentValue: this.$t('productDetail.d98ArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey2'),
          argumentValue: this.$t('productDetail.d98ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey3'),
          argumentValue: this.$t('productDetail.d92ArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey4'),
          argumentValue: this.$t('productDetail.d98ArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey5'),
          argumentValue: this.$t('productDetail.d98ArgumentValue5')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey6'),
          argumentValue: this.$t('productDetail.d98ArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey7'),
          argumentValue: this.$t('productDetail.d98ArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey8'),
          argumentValue: this.$t('productDetail.d98ArgumentValue8')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey9'),
          argumentValue: this.$t('productDetail.d98ArgumentValue9')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey10'),
          argumentValue: this.$t('productDetail.d98ArgumentValue10')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey11'),
          argumentValue: this.$t('productDetail.d98ArgumentValue11')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey13'),
          argumentValue: this.$t('productDetail.d92ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey14'),
          argumentValue: this.$t('productDetail.d98ArgumentValue14')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey15'),
          argumentValue: this.$t('productDetail.d98ArgumentValue15')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey16'),
          argumentValue: this.$t('productDetail.d98ArgumentValue16')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey17'),
          argumentValue: this.$t('productDetail.d92ArgumentValue3'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey18'),
          argumentValue: this.$t('productDetail.d98ArgumentValue18')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey19'),
          argumentValue: this.$t('productDetail.d98ArgumentValue19')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey20'),
          argumentValue: '68mm*68mm*21.6mm'
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey21'),
          argumentValue: '72.8g'
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey22'),
          argumentValue: '-20°C~70°C'
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey23'),
          argumentValue: '-40°C~80°C'
        }]
      }, {
        proType: 'D82',
        proTitle: 'D82' + this.$t('productDetail.locator'),
        productUrl: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_8.png',
        brightInfo: [this.$t('productDetail.d98Brighttext1'), this.$t('productDetail.d98Brighttext2'), this.$t('productDetail.d82Brighttext1'), this.$t('productDetail.d82Brighttext2'), this.$t('productDetail.d82Brighttext3'), this.$t('productDetail.d82Brighttext4')],
        argument: [{
          argumentKey: this.$t('productDetail.d98ArgumentKey1'),
          argumentValue: this.$t('productDetail.d98ArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey2'),
          argumentValue: this.$t('productDetail.d98ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey3'),
          argumentValue: this.$t('productDetail.d82ArgumentValue1'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey4'),
          argumentValue: this.$t('productDetail.d98ArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey5'),
          argumentValue: this.$t('productDetail.d82ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey6'),
          argumentValue: this.$t('productDetail.d98ArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey7'),
          argumentValue: this.$t('productDetail.d98ArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey8'),
          argumentValue: this.$t('productDetail.d82ArgumentValue3')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey9'),
          argumentValue: this.$t('productDetail.d82ArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey10'),
          argumentValue: this.$t('productDetail.d82ArgumentValue5')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey11'),
          argumentValue: this.$t('productDetail.d98ArgumentValue11')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey12'),
          argumentValue: this.$t('productDetail.d82ArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey14'),
          argumentValue: this.$t('productDetail.d98ArgumentValue14')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey15'),
          argumentValue: this.$t('productDetail.d82ArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey15'),
          argumentValue: this.$t('productDetail.d82ArgumentValue8')
        }, {
          argumentKey: this.$t('productDetail.d82ArgumentKey1'),
          argumentValue: this.$t('productDetail.d82ArgumentValue9'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey18'),
          argumentValue: this.$t('productDetail.d98ArgumentValue18'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey19'),
          argumentValue: this.$t('productDetail.d82ArgumentValue10'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey20'),
          argumentValue: this.$t('productDetail.d82ArgumentValue11'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey21'),
          argumentValue: this.$t('productDetail.d82ArgumentValue12'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey22'),
          argumentValue: this.$t('productDetail.d98ArgumentValue22'),
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey23'),
          argumentValue: this.$t('productDetail.d98ArgumentValue23'),
        }]
      }, {
        proType: 'D60',
        proTitle: 'D60' + this.$t('productDetail.locator'),
        productUrl: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_9.png',
        brightInfo: [this.$t('productDetail.d60Brighttext1'), this.$t('productDetail.d60Brighttext2'),this.$t('productDetail.d60Brighttext3'),this.$t('productDetail.d60Brighttext4'),this.$t('productDetail.d60Brighttext5'),this.$t('productDetail.d60Brighttext6')],
        argument: [{
          argumentKey: this.$t('productDetail.d98ArgumentKey4'),
          argumentValue: this.$t('productDetail.d60ArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey1'),
          argumentValue: this.$t('productDetail.d60ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey2'),
          argumentValue: this.$t('productDetail.d60ArgumentValue3')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey3'),
          argumentValue: this.$t('productDetail.d60ArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey4'),
          argumentValue: this.$t('productDetail.d60ArgumentValue5')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey5'),
          argumentValue: this.$t('productDetail.d60ArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey6'),
          argumentValue: this.$t('productDetail.d60ArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d60ArgumentKey7'),
          argumentValue: this.$t('productDetail.d60ArgumentValue8')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey20'),
          argumentValue: this.$t('productDetail.d60ArgumentValue9')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey21'),
          argumentValue: this.$t('productDetail.d60ArgumentValue10')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey22'),
          argumentValue: this.$t('productDetail.d60ArgumentValue11')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey23'),
          argumentValue: this.$t('productDetail.d60ArgumentValue12')
        }]
      }, {
        proType: '蓝牙信标',
        proTitle: this.$t('home.productBlueTooth'),
        productUrl: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_10.png',
        brightInfo: [],
        argument: [{
          argumentKey: this.$t('productDetail.d98ArgumentKey1'),
          argumentValue: this.$t('productDetail.bTArgumentValue1')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey2'),
          argumentValue: this.$t('productDetail.d98ArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey3'),
          argumentValue: this.$t('productDetail.d98ArgumentValue3')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey4'),
          argumentValue: this.$t('productDetail.bTArgumentValue2')
        }, {
          argumentKey: this.$t('productDetail.bTArgumentKey1'),
          argumentValue: this.$t('productDetail.bTArgumentValue3')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey9'),
          argumentValue: this.$t('productDetail.bTArgumentValue4')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey11'),
          argumentValue: this.$t('productDetail.bTArgumentValue5')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey13'),
          argumentValue: this.$t('productDetail.bTArgumentValue6')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey14'),
          argumentValue: this.$t('productDetail.d98ArgumentValue14')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey15'),
          argumentValue: this.$t('productDetail.d98ArgumentValue15')
        }, {        
            argumentKey: this.$t('productDetail.d98ArgumentKey16'),
          argumentValue: this.$t('productDetail.d98ArgumentValue16')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey17'),
          argumentValue: this.$t('productDetail.bTArgumentValue7')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey18'),
          argumentValue: this.$t('productDetail.bTArgumentValue8')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey19'),
          argumentValue: this.$t('productDetail.d98ArgumentValue19')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey20'),
          argumentValue: this.$t('productDetail.bTArgumentValue9')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey21'),
          argumentValue: this.$t('productDetail.bTArgumentValue10')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey22'),
          argumentValue: this.$t('productDetail.bTArgumentValue11')
        }, {
          argumentKey: this.$t('productDetail.d98ArgumentKey23'),
          argumentValue: this.$t('productDetail.bTArgumentValue12')
        }, {
          argumentKey: this.$t('productDetail.bTArgumentKey2'),
          argumentValue: this.$t('productDetail.bTArgumentValue13')
        }]
      }],
      isActive: this.productId || 'D98'
    }
  },
  computed: {
    productInfo () {
      return this.productList.find(item => item.proType === this.isActive)
    }
  },
  methods: {
    handProduct (event) {
      this.isActive = event.deptType
    },
    handBackproduct () {
      this.$emit('handMenu', 2, 'Product')
    }
  },
  components: { Animation, Banner, Footer }
}
</script>

<style scoped lang="scss">
</style>
